import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdministrativeIndicationAnalyticsV2Service } from './services/administrative-indication-analytics-v2.service';
import { IndicationAnalytic } from './contracts/indication-analytics';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { PageEvent } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DoctorService } from 'src/app/services/doctor.service';
import {
  DoctorV2Service,
  ListDoctorsResponse,
} from 'src/app/services/doctor-v2.service';

@Component({
  selector: 'app-indication-analytics',
  templateUrl: './indication-analytics.component.html',
  styleUrls: ['./indication-analytics.component.scss'],
})
export class IndicationAnalyticsComponent implements OnInit, OnDestroy {
  dataSource: MatTableDataSource<IndicationAnalytic> = new MatTableDataSource(
    []
  );
  total = 0;
  pageIndex = 0;
  pageSize = 10;
  isLoading = false;

  tableColumns: string[] = [
    'indicationStatus',
    'indicationDocumentUrl',
    'accountName',
    'scheduleDate',
    'scheduleDoctorName',
    'transactionAmount',
    'transactionAddress',
    'invoiceId',
    'invoiceStatus',
  ];

  doctorForm: FormGroup;
  schedulesForm: FormGroup;

  doctorOptions: ListDoctorsResponse[] = [];

  private subs = new Subscription();
  private assasLink = environment.asaasInvoiceLink;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly administrativeIndicationAnalyticsV2Service: AdministrativeIndicationAnalyticsV2Service,
    private readonly doctorService: DoctorV2Service
  ) {}

  ngOnInit(): void {
    this.listDoctors();

    this.doctorForm = this.formBuilder.group({
      id: [[]],
    });

    this.schedulesForm = this.formBuilder.group({
      dateFrom: [],
      dateTo: [],
    });

    this.onSearch();
  }

  onSearch(event?: PageEvent, reset = false) {
    this.isLoading = true;
    this.dataSource.data = [];
    this.total = 0;

    if (!event) {
      this.pageIndex = 0;
    } else {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }

    const doctorFormValues = this.doctorForm.getRawValue();
    const scheduleFormValues = this.schedulesForm.getRawValue();

    const filter: any = {};
    const schedules: any = {};

    if (doctorFormValues.id) {
      schedules.doctor = { id: doctorFormValues.id };
    }

    if (scheduleFormValues.dateFrom && scheduleFormValues.dateTo) {
      const dateFrom = this.formatDateToYMD(scheduleFormValues.dateFrom);
      const dateTo = this.formatDateToYMD(scheduleFormValues.dateTo);

      console.log('dateFrom', dateFrom);

      schedules.date = [`${dateFrom}T00:00:00`, `${dateTo}T23:59:59`];
    }

    if (schedules) {
      filter.schedules = schedules;
    }

    this.administrativeIndicationAnalyticsV2Service
      .search({
        filter,
        page: this.pageIndex + 1,
        perPage: this.pageSize,
      })
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((datatable) => {
        console.log(datatable);
        this.dataSource.data = datatable.rows;

        this.total = datatable.total;
      });
  }

  clearFilter() {
    this.doctorForm.setValue({
      id: [],
    });

    this.schedulesForm.setValue({
      dateFrom: null,
      dateTo: null,
    });

    this.onSearch();
  }

  generateInvoiceLink(nfeId: string): string {
    const id = nfeId.replace(/^inv_0*/, '');
    return `${this.assasLink}/${id}`;
  }

  generateInvoiceId(nfeId: string): string {
    const onlyNumbers = nfeId.replace(/\D/g, '');
    const noLeadingZeros = onlyNumbers.replace(/^0+/, '');
    return noLeadingZeros;
  }

  formatDateToYMD(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  private listDoctors() {
    this.doctorService.findAll().subscribe((doctors) => {
      this.doctorOptions = doctors;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
